export default __webpack_public_path__ + "static/media/src_img_12.aa70ba81.jpg";